export default __webpack_public_path__ + "static/user_research-4ed25092e156a8872d62d41e9bf13cbd.png";